import React from 'react';
import style from '../../assets/styles/RequestListToBePrepared.module.scss';

export const PdvLegendAndWarnings = ({
  warningsEnabled,
  onToggleWarnings,
}) => {
  return (
    <div className={style.warningToggleWrapper}>
      <div className={style.pdvLegendBar} data-testid="pdv-legend-bar">
        <div className={style.legendItem} title="Pedido em preparo na cozinha / Não pago">
          <span className={`${style.legendSquare} ${style.legendRed}`} />
          <span>Em Preparo</span>
        </div>
        <div className={style.legendItem} title="Prato pronto na cozinha aguardando garçom levar à mesa">
          <span className={`${style.legendSquare} ${style.legendOrange}`} />
          <span>Prato Pronto</span>
        </div>
        <div className={style.legendItem} title="Cliente solicitou a conta da mesa">
          <span className={`${style.legendSquare} ${style.legendGreen}`} />
          <span>Pediu a Conta</span>
        </div>
        <div className={style.legendItem} title="Cliente chamou o garçom">
          <span className={`${style.legendSquare} ${style.legendBlue}`} />
          <span>Chamou Garçom</span>
        </div>
        <div className={style.legendItem} title="Conta já paga">
          <span className={`${style.legendSquare} ${style.legendYellow}`} />
          <span>Pago</span>
        </div>
        <div className={style.legendItem} title="Pratos entregues na mesa">
          <span className={`${style.legendSquare} ${style.legendWhite}`} />
          <span>Entregue</span>
        </div>
      </div>
      <label
        className={style.warningToggleLabel}
        title="Receber popups na tela de chamados de garçom e solicitações de conta"
      >
        <input
          type="checkbox"
          checked={warningsEnabled}
          onChange={(e) => onToggleWarnings(e.target.checked)}
          data-testid="warning-toggle-checkbox"
        />
        <span>Receber avisos de chamados</span>
      </label>
    </div>
  );
};

export default PdvLegendAndWarnings;

